<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div v-if="loading && errorMessage" class="topRemark">
      {{ errorMessage }}
    </div>
    <div v-if="loading && !errorMessage" class="topRemark">
      <b :style="'color: '+GetColorMain()">{{ data.proUseName }}</b>教练邀请您填写{{ data.groupTeam }} <b :style="'color: '+GetColorMain()">{{ data.picCourse }}</b>资质认证信息，请尽快并准确填写下面个人信息以便尽快注册您的潜水员资质证书。
    </div>
    <div v-if="loading && !errorMessage" class="fastRect">
      <div class="title">认证信息<span>请核对证书类型是否正确</span></div>
      <van-field
        v-model="data.picId"
        clearable
        readonly
        label="认证号"
      />
      <van-field
        v-model="data.groupTeam"
        clearable
        readonly
        label="机构"
      />
      <van-field
        v-model="data.picTypeName"
        clearable
        readonly
        label="类型"
      />
      <van-field
        v-model="data.picCourse"
        clearable
        readonly
        label="证书"
        placeholder="请选择证书"
      />
      <van-field
        v-model="createTime"
        clearable
        readonly
        label="创建时间"
      />
      <template v-if="data.verifyProTime">
        <div class="van-cell van-field">
          <div class="van-cell__title van-field__label"><span>审核时间</span></div>
          <div :style="'color: '+GetColorMain()">
            {{ formatDate(data.verifyProTime,"yyyy/MM/dd hh:mm") }}
          </div>
        </div>
        <div class="van-cell van-field">
          <div class="van-cell__title van-field__label"><span>审核意见</span></div>
          <div :style="'color: '+GetColorMain()">
            {{ data.verifyProAbout }}
          </div>
        </div>
      </template>
    </div>

    <div v-if="loading && !errorMessage" class="fastRect">
      <div class="title">学员信息<span>请如实填写信息</span></div>
      <template v-if="customerInfoEdit">
        <van-field
          v-model="customerInfoData.loaclName"
          clearable
          label="本地姓名"
          maxlength="32"
          required
          placeholder="请输入本地姓名"
        />
        <van-field
          v-model="customerInfoData.lastName"
          clearable
          label="英文(拼音)姓"
          maxlength="32"
          required
          placeholder="请输入英文(拼音)姓"
        />
        <van-field
          v-model="customerInfoData.firstName"
          clearable
          label="英文(拼音)名"
          maxlength="32"
          required
          placeholder="请输入英文(拼音)名"
        />
        <van-field
          v-model="birthday"
          clearable
          label="生日"
          required
          readonly=""
          placeholder="请选择出生日期"
          @click="showBirthday=true"
        />
        <van-field
          v-model="customerInfoData.email"
          clearable
          label="邮箱"
          maxlength="128"
          required
          placeholder="请输入电子邮箱"
        />
        <FieldSelect v-model="sex" :list="sexList" label="性别" placeholder="请选择性别" @change="onSexChange" />
      </template>
      <template v-if="!customerInfoEdit">
        <div v-for="item in customerInfoList" :key="item.customerLogId" class="customerRect" @click="onSelectCustomer(item)">
          {{ item.loaclName }}({{ item.lastName }} {{ item.firstName }})
        </div>
        <div class="customerRect" @click="onSelectCustomer()">
          新的学员信息
        </div>
      </template>
    </div>
    <div v-if="customerInfoEdit && !errorMessage" class="fastRect">
      <div class="title">邮寄信息<span>请如实填写信息</span></div>
      <FieldSelect v-model="country" :list="countryList" label="国家" placeholder="请选择国家" @change="onCountryChange" />
      <van-field
        v-if="customerInfoData.country==='CHN'"
        v-model="zip"
        required
        clearable
        label="地区"
        placeholder="选择省/市/区"
        readonly
        @click="selectArea"
      />
      <van-field
        v-if="customerInfoData.country!=='CHN'"
        v-model="customerInfoData.cityEng"
        clearable
        label="城市"
        maxlength="64"
        required
        placeholder="城市(英文)"
      />
      <van-field
        v-model="customerInfoData.address"
        clearable
        label="地址"
        maxlength="256"
        required
        placeholder="街道门牌、楼层房间号等信息"
      />
      <van-field
        v-model="customerInfoData.postalCode"
        clearable
        label="邮编"
        maxlength="12"
        required
        placeholder="请输入邮政编码"
      />
      <van-field
        v-model="customerInfoData.phone"
        clearable
        label="手机号码"
        maxlength="11"
        required
        placeholder="请输入手机号码"
      />
    </div>
    <div v-if="customerInfoEdit && !errorMessage" class="fastRect">
      <div class="title">认证照片<span>请上传本人照片</span></div>
      <div class="IconRect">
        <div class="tools" @click="rotateImg"><i class="iconfont iconrotate" /></div>
        <vueCropper
          ref="cropper"
          class="cutIconRect"
          :img="option.img"
          :output-size="option.size"
          :output-type="option.outputType"
          :info="false"
          :full="option.full"
          :can-move="option.canMove"
          :can-move-box="option.canMoveBox"
          :original="option.original"
          :auto-crop="option.autoCrop"
          :fixed="option.fixed"
          :fixed-number="option.fixedNumber"
          :center-box="option.centerBox"
          :fixed-box="option.fixedBox"
          :max-img-size="option.maxImgSize"
          :enlarge="option.enlarge"
          :auto-crop-width="option.autoCropWidth"
          :auto-crop-height="option.autoCropHeight"
        />
        <van-uploader :after-read="onRead">
          <van-button type="default" size="small" class="buttonChooseImg" :color="GetColorMain()">选择照片</van-button>
        </van-uploader>
        <div class="photoAbout">注:该照片用于帮助识别持卡人,请勿带墨镜/潜水面镜/帽子。如您提交了不符合要求的照片,将有可能延迟您的卡片认证。</div>
      </div>
    </div>
    <div class="downButton">
      <van-button v-if="loading &&!errorMessage" type="danger" :color="GetColorMain()" style="width:100%" :loading="buttonLoading" @click="onNext">下一步</van-button>
      <van-button v-if=" loading &&errorMessage" type="danger" :color="GetColorMain()" style="width:100%" @click="onBack">返回</van-button>
    </div>
    <dateSelect v-model="showBirthday" :default-date="birthday" @onChange="onBirthdayChange" />
    <van-popup v-model="showAreaSelect" position="bottom">
      <van-area ref="pickerArea" :value="customerInfoData.zip==undefined?'110000':customerInfoData.zip.toString()" :loading="arealoading" :area-list="areaData" @confirm="confirmArea" @cancel="showAreaSelect=false" />
    </van-popup>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Field, Switch, Popup, Checkbox, Area, Uploader, Dialog } from 'vant'
import TopBar from '@/components/TopBar'
import FieldSelect from '@/components/FieldSelect'
import { MyNotify, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import dateSelect from '@/components/dateSelect'
import { VueCropper } from 'vue-cropper'
export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Switch.name]: Switch,
    [Popup.name]: Popup,
    [Checkbox.name]: Checkbox,
    [Area.name]: Area,
    [Uploader.name]: Uploader,
    [Dialog.name]: Dialog,
    TopBar,
    dateSelect,
    FieldSelect,
    VueCropper
  },
  data() {
    return {
      titleTop: '',
      title: '认证信息填写',
      backurl: '/my/index',
      loading: false,
      code: undefined,
      createTime: '',
      state: '',
      buttonLoading: false,
      errorMessage: undefined,
      data: {

      },
      customerInfoList: [],
      customerInfoEdit: false,
      customerInfoData: {

      },
      showBirthday: false,
      sexList: [],
      sex: undefined,
      birthday: undefined,
      countryList: [],
      showAreaSelect: false,
      zip: undefined,
      areaData: undefined,
      arealoading: false,
      changeUserHead: false,
      country: '',
      option: {
        img: '', // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: 'jpg', // 裁剪生成图片的格式
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [10, 13], // 截图框的宽高比例
        full: false, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        maxImgSize: 2000,
        enlarge: 1,
        autoCropWidth: 200,
        autoCropHeight: 260
      }
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.code = this.$route.params.id
    this.init(() => {
      this.loadCustomerInfoList(() => {
      })
    })
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    checkInputData(data) {
      if (!this.customerInfoEdit) {
        MyNotify('info', '请选择一个学员或者‘新建一个学员信息’')
        return false
      }
      if (!data.loaclName || data.loaclName.length < 2) {
        MyNotify('info', '请输入至少2位中文姓名')
        return false
      }
      if (!data.lastName || data.lastName.length < 2) {
        MyNotify('info', '请输入英文(拼音)姓')
        return false
      }
      if (!data.firstName || data.firstName.length < 2) {
        MyNotify('info', '请输入英文(拼音)名')
        return false
      }
      if (!data.birthday) {
        MyNotify('info', '请选择出生日期')
        return false
      }
      if (!data.email || data.email.length < 5) {
        MyNotify('info', '请输入电子邮箱')
        return false
      }
      if (!data.sex || data.sex.length < 1) {
        MyNotify('info', '请选择性别')
        return false
      }
      if (data.country === 'CHN') {
        if (!data.zip || data.zip.length < 1) {
          MyNotify('info', '选择省/市/区')
          return false
        }
      }
      if (!data.address || data.address.length < 1) {
        MyNotify('info', '请输入街道门牌、楼层房间号等信息')
        return false
      }
      if (!data.postalCode || data.postalCode.length < 4) {
        MyNotify('info', '请输入邮政编码')
        return false
      }
      if (!data.phone || data.phone.length < 5) {
        MyNotify('info', '请输入至少5位电话号码')
        return false
      }
      if (!this.option.img || this.option.img === '') {
        MyNotify('info', '请上传认证照片')
        return false
      }
      return true
    },
    onNext() {
      if (!this.checkInputData(this.customerInfoData)) {
        return
      }
      this.buttonLoading = true
      var height = this.$refs.cropper.cropH
      var bl = 260.0 / height
      this.option.enlarge = bl
      this.$refs.cropper.getCropData((data) => {
        if (this.changeUserHead) {
          this.customerInfoData.data = data
        } else {
          this.customerInfoData.data = undefined
        }
        this.onUploadCustomerInfo(customerId => {
          console.log('顾客信息序号', customerId)
          this.UserSelectPicCustomerInfo(this.code, customerId)
        })
      })
    },
    initCountryList(callback) {
      request({
        url: '/Pro/getPadiCountry',
        method: 'post'
      }).then(Response => {
        if (!Response.success) {
          return
        }
        this.countryList = []
        Response.data.forEach(item => {
          this.countryList.push({ text: item.name, value: item.code3 })
        })
        this.country = this.customerInfoData.country
        console.log('customerInfoData1', this.customerInfoData)
        if (callback) {
          console.log('this.countryList', this.countryList)
          callback()
        }
      })
    },
    onUploadCustomerInfo(callback) {
      this.customerInfoData.isProUsed = false
      request({
        url: '/StoreHelper/updateCustomerInfo',
        method: 'post',
        data: this.customerInfoData
      }).then(Response => {
        if (!Response.success) {
          this.buttonLoading = false
          return
        }
        if (callback) {
          callback(Response.data)
        }
      })
    },
    UserSelectPicCustomerInfo(code, customerId) {
      request({
        url: '/pro/UserSelectPicCustomerInfo',
        method: 'post',
        data: {
          customerId: customerId,
          code: code
        }
      }).then(Response => {
        this.buttonLoading = false
        if (!Response.success) {
          return
        }
        this.$router.push('/pic/picState/' + code)
      })
    },
    onBack() {
      window.history.length >= 1
        ? this.$router.go(-1)
        : this.$router.push(this.backurl)
    },
    onBirthdayChange(date) {
      this.customerInfoData.birthday = date
      this.birthday = formatDate(date, 'yyyy/MM/dd')
    },
    onSexChange(select) {
      this.customerInfoData.sex = select.value
    },
    onCountryChange(select) {
      this.customerInfoData.country = select.value
      this.customerInfoData = JSON.parse(JSON.stringify(this.customerInfoData))
      this.country = select.value
    },
    init(callback) {
      request({
        url: '/Pro/getPicByCode',
        method: 'post',
        params: { code: this.code }
      }).then(Response => {
        this.loading = true
        if (!Response.success) {
          this.errorMessage = Response.message
          return
        }
        this.data = Response.data
        console.log('this.data', this.data)
        if (this.data.customerInfo) {
          this.onSelectCustomerDo(this.data.customerInfo)
        } else {
          this.customerInfoEdit = false
        }
        if (this.data.state !== 'WAIT') {
          this.$router.push('/pic/picState/' + this.code)
        }
        this.createTime = formatDate(this.data.createTime, 'yyyy/MM/dd hh:mm', true)
        if (callback) {
          callback()
        }
      })
    },
    loadCustomerInfoList(callback) {
      request({
        url: '/StoreHelper/getUserCustomerInfoList',
        method: 'post'
      }).then(Response => {
        if (!Response.success) {
          return
        }

        this.customerInfoList = Response.data
        if (!this.customerInfoEdit) {
          if (this.customerInfoList.length === 0) {
            this.onSelectCustomerDo()
          } else {
            this.customerInfoEdit = false
          }
        }
        if (callback) {
          callback()
        }
      })
    },
    onSelectCustomer(item) {
      if (item) {
        Dialog.confirm({
          title: '选择学员信息',
          message: '是否要选择' + item.loaclName + ' (' + item.lastName + ' ' + item.firstName + ') 学员?'
        }).then(() => {
          this.onSelectCustomerDo(item)
        })
      } else {
        Dialog.confirm({
          title: '新的学员信息',
          message: '是否要新建一个学员信息?'
        }).then(() => {
          this.onSelectCustomerDo(item)
        })
      }
    },
    onSelectCustomerDo(item) {
      if (!item) {
        this.customerInfoEdit = true
        this.customerInfoData = {
        }
      } else {
        this.customerInfoEdit = true
        this.customerInfoData = item
      }
      this.initCountryList()
      setTimeout(() => {
        this.sexList = []
        this.sexList.push({ text: '男性', value: 'MALE' })
        this.sexList.push({ text: '女性', value: 'FEMALE' })
        console.log('this.sexList ', this.sexList)
        if (item) {
          this.sex = this.customerInfoData.sex
          this.zip = this.customerInfoData.zipString
          this.option.img = this.customerInfoData.headIcon
          if (this.customerInfoData.birthday) {
            this.birthday = formatDate(this.customerInfoData.birthday, 'yyyy/MM/dd')
          }
        }
      }, 5)
    },
    selectArea() {
      this.showAreaSelect = true
      this.readAreaData()
    },
    readAreaData() {
      if (this.areaData !== undefined) {
        return
      }
      this.arealoading = true
      request({
        url: '/data/getArea',
        method: 'post'
      }).then(Response => {
        this.areaData = Response
        this.arealoading = false
      })
    },
    confirmArea(selectList) {
      var title = ''
      var zipId = 0
      selectList.forEach(item => {
        title += item.name + ' '
        zipId = item.code
      })
      this.zip = title
      this.customerInfoData.zip = zipId
      this.showAreaSelect = false
    },
    onRead(file) {
      this.option.img = file.content
      this.changeUserHead = true
    },
    rotateImg() {
      if (this.option.img === undefined || this.option.img == null || this.option.img === '') {
        return
      }
      this.$refs.cropper.rotateRight()
    }
  }
}
</script>
<style>
.van-uploader{
  width: 100% !important;
}
.van-uploader__input-wrapper{
  width: 100% !important;
}
.uploadbutton button{
  width: 100%;
}
</style>
<style scoped>
.fastRect{
    background-color: #fff;
    border-radius: 0.3em;
    padding: 0.5em;
    margin: 1em;
}
.fastRect .title{
    font-size: 1.1em;
    font-weight: 700;
    padding: 0.3em 0 0.3em 0.9em;
}
.fastRect .title span{
  font-size: 0.7em;
  color: #999;
  padding-left: 0.4em;
  font-weight: 400;
}
.downButton{
    margin: 1em;
}
.topRemark{
    background-color: #fff;
    border-radius: 0.3em;
    padding: 2em;
    margin: 1em;
    font-size: 0.9em;
    text-align: center;
}
.cutIconRect{
    width: 100%;
    height: 15em !important;
}
.tools{
  position: absolute;
  right: 0.5em;
  top:0.5em;
  z-index: 999;
  width: 2em;
  height: 2em;
  line-height: 2em;
  border-radius: 1em;
  text-align: center;
  background-color: #fff;
}
.IconRect{
  overflow: hidden;
  position: relative;
}
.buttonChooseImg{
  width: 100%;
  color: #fff;
  border:none;
  border-bottom-left-radius: 0.4em;
  border-bottom-right-radius: 0.4em;
  height: 3em;
  line-height: 3em;
}
.photoAbout{
  font-size: 0.6em;
  color: #999;
}
.customerRect{
  padding: 0.5em 1em;
  border: 1px solid #ccc;
  margin-bottom: 0.5em;
}
</style>
